import { render, staticRenderFns } from "./coordination.vue?vue&type=template&id=dd9b71e6"
import script from "./coordination.vue?vue&type=script&lang=js"
export * from "./coordination.vue?vue&type=script&lang=js"
import style0 from "./coordination.vue?vue&type=style&index=0&id=dd9b71e6&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports